import { getAuditLogs } from '@/service/audit-logs'

const initialState = () => ({
  loading: false,
  auditLogs: [],
  total: 0,
})

const state = initialState()

const getters = {
  loading: state => state.loading,
  auditLogs: state => state.auditLogs,
  total: state => state.total,
}

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setAuditLogs(state, auditLogs) {
    state.auditLogs = auditLogs
  },
  setTotal(state, total) {
    state.total = total
  },
}

const actions = {
  loadAuditLogs({ commit }, { offset, limit, entity, action, text }) {
    commit('setLoading', true)
    return getAuditLogs({ offset, limit, entity, action, text }).then(
      ({ data }) => {
        const { auditLogs, metadata } = data
        commit('setAuditLogs', auditLogs)
        commit('setTotal', metadata.total)
        commit('setLoading', false)
      }
    )
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
